import { mapSelectors } from '@citypantry/util';
import { getCreateStaffUserState } from '../app.state';
import { CreateStaffUserState } from './create-staff-user.state';

export const isSubmitting = (state: CreateStaffUserState) => state.isSubmitting;

export const CreateStaffUserSelectors = mapSelectors(getCreateStaffUserState, {
  isSubmitting,
});
